import React from 'react';
import { Link } from 'react-router-dom';
import './style.css'
import logo from './../../images/logo.svg'

function Navigation(){
  return(
    <nav className="admin__nav">
      <div className="header__logo">
        <img src={logo} alt="AB hires"/>
        <h1>AB hires</h1>
      </div>
      <ul className="admin__nav__list">
        <li  className="admin__nav__item"><Link to="/admin/">DASHBOARD</Link></li>
        <li  className="admin__nav__item"><Link to="/admin/homepage">HOMEPAGE</Link></li>
        <li  className="admin__nav__item"><Link to="/admin/jobs">JOBS</Link></li>
        <li  className="admin__nav__item"><Link to="/admin/testimonals">TESTIMONALS</Link></li>
        <li  className="admin__nav__item"><Link to="/admin/employerzone">EMPLOYER ZONE</Link></li>
      </ul>
    </nav>
  )
}

export default Navigation
